import {WebStorageStateStore} from "oidc-client-ts";
import React, {PropsWithChildren, useMemo} from "react";
import {AuthProvider} from "react-oidc-context";
import {getOidcConfig, toUserManagerSettings} from "./config";

export function SafecubeAuthProvider({children}: PropsWithChildren<unknown>) {
	const settings = useMemo(() => ({
		...toUserManagerSettings(getOidcConfig()),
		userStore: new WebStorageStateStore({store: window.localStorage}),
	}), []);

	return (
		<AuthProvider {...settings}>
			{children}
		</AuthProvider>
	);
}
